import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import projectUrl from './Url';
import fetchData from './GlobalFetchApi';

const SEOHelmet = ({ page, collegeId }) => {
  const [seoData, setSeoData] = useState({
    title: '',
    keywords: '',
    descriptions: '',
  });

  useEffect(() => {
    const getSeoData = async () => {
      const bodyData = {
        page: page,
        ...(collegeId && { college_id: collegeId }),
      };

      try {
        const response = await fetchData.post(projectUrl.seoGet, {}, bodyData);
        if (response && response.data) {
          setSeoData(response.data);
        }
      } catch (error) {
        console.error('Failed to fetch SEO data:', error);
      }
    };

    getSeoData();
  }, [page, collegeId]);

  return (
    <Helmet>
      <title>{seoData.title}</title>
      <meta name="description" content={seoData.descriptions} />
      <meta name="keywords" content={seoData.keywords} />
    </Helmet>
  );
};

export default SEOHelmet;
